<div
    class="w-full min-h-0 flex flex-col items-center justify-start px-4 sm:px-6 flex-1 overflow-y-auto scrollbar-transparent pb-6">
    <h2
        class="text-2xl font-semibold tracking-tight text-balance text-primary sm:text-4xl md:text-5xl text-center sm:text-left use-grotesque">
        What's your business
        <span class="bg-gradient-to-r from-primary to-brand-studio bg-clip-text text-transparent">website?</span>
    </h2>
    <p class="mx-auto mt-2 max-w-xl text-base sm:text-lg/8 text-pretty text-secondary text-center sm:text-left w-full">
        We'll
        analyze your website and set everything up automatically.</p>


    <div class="w-full max-w-4xl flex flex-col gap-y-4 py-6 sm:py-8">
        <!-- <div class="mt-6 shadow-card-container p-4 flex flex-col gap-y-4 divide-y divide-zinc-200 dark:divide-zinc-800"> -->
        @if (!selectedBrand()) {
        <div class="mt-6 flex flex-col gap-y-4">
            @if (manualBrandEntry()) {
            <div class="w-full flex flex-col gap-y-4 pb-4">
                <button type="button" (click)="switchToSearchMode()"
                    class="self-start text-sm font-semibold text-accent hover:text-primary/85 dark:hover:text-primary/85  py-2 touch-manipulation">
                    Search with website instead
                </button>
                <p class="text-sm text-secondary text-left max-w-xl">Add your brand name, logo and brand details,
                    public website, and a short description. We use this to create your business profile.</p>

                <ng-container *ngTemplateOutlet="editableBrandFields" />

                <div class="w-full flex flex-row items-cente justify-end">
                    <button type="button" (click)="applyManualBrand()"
                        class="w-full sm:w-auto self-start text-center secondary-button text-secondary rounded-md px-4 py-3 text-base font-semibold  touch-manipulation">
                        Use these details
                    </button>
                </div>
            </div>
            } @else {
            <div class="w-full flex flex-col gap-y-2 pb-4">
                <label for="companyWebsiteInput" class="block text-sm/6 font-medium text-primary text-left">Your
                    website URL</label>
                <div class="mt-2 flex">
                    <div
                        class="flex shrink-0 items-center rounded-l-md bg-white/50 dark:bg-white/5 px-3 text-base text-gray-500 dark:text-gray-400 outline outline-1 -outline-offset-1 outline-zinc-300 dark:outline-white/10 sm:text-sm/6">
                        https://</div>
                    <input [formField]="brandFetchForm.domain" #companyWebsiteInput id="companyWebsiteInput" type="text"
                        placeholder="example.com" autocomplete="url"
                        class="input-url text-primary text-base rounded-r-md flex-1" />
                </div>
                <p class="text-sm text-secondary text-left max-w-full mt-1">Enter your customer-facing website domain to
                    search for your brand.</p>
                <div class="flex flex-row items-center justify-start gap-x-2 mt-2">
                    <button type="button" (click)="resetBrandSearch()"
                        class="secondary-button text-primary px-2 py-2 -mx-2 touch-manipulation rounded-md hover:text-primary">
                        Clear search
                    </button>
                </div>

                @if (brandSearchLoading()) {
                <p class="text-sm text-secondary mt-2" aria-live="polite">Searching for your brand…</p>
                }

                @if (!brandSearchLoading() && brandSuggestions() !== undefined) {
                <p class="sr-only" aria-live="polite" aria-atomic="true">
                    @if (brandSuggestions()!.length === 0) {
                    No matching brands found.
                    } @else {
                    {{ brandSuggestions()!.length }} brands found.
                    }
                </p>
                }

                @if (brandSuggestions() && brandSuggestions()!.length > 0) {
                <div class="grid grid-cols-1 gap-2 sm:grid-cols-2 mt-2">
                    @for (brand of brandSuggestions(); track brand.brandId) {
                    <div (click)="onBrandSelect(brand)" (keydown)="onBrandSuggestionKeydown($event, brand)"
                        role="button" tabindex="0"
                        class="relative flex items-center space-x-3 rounded-lg border border-gray-200 dark:border-white/10 bg-gray-100 dark:bg-zinc-800/50 px-3 py-3 sm:px-2 sm:py-2  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary hover:border-gray-300 dark:hover:border-white/25 touch-manipulation active:bg-gray-200 dark:active:bg-zinc-800/70">
                        <div class="shrink-0">
                            <img [src]="brand.icon" [alt]="brand.name + ' logo'"
                                class="size-10 rounded-full bg-gray-200 dark:bg-zinc-700 outline outline-1 -outline-offset-1 outline-gray-300 dark:outline-white/10" />
                        </div>
                        <div class="min-w-0 flex-1 flex flex-row items-center justify-between hover:cursor-pointer">
                            <div class="text-left">
                                <p class="text-sm font-medium text-primary">{{ brand.name }}</p>
                                <p class="truncate text-sm text-secondary">{{ brand.domain }}</p>
                            </div>

                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-secondary" aria-hidden="true">
                                <path d="m9 18 6-6-6-6" />
                            </svg>
                        </div>
                    </div>
                    }
                </div>

                } @else if (!brandSearchLoading() && brandSuggestions() && brandSuggestions()!.length === 0) {
                <div class="mt-3 flex flex-col gap-3 items-center sm:items-start text-center sm:text-left">
                    <p class="text-sm/6 text-secondary max-w-xl">
                        We could not find a match for that website. Try another domain, clear your search, or enter your
                        details manually.
                    </p>
                    <button type="button" (click)="enterManualBrandMode()"
                        class="text-sm font-semibold text-accent hover:text-white/85 dark:hover:text-white/85  px-3 py-2 touch-manipulation rounded-md">
                        Enter manually
                    </button>
                </div>
                }

                <div class="mt-4 flex justify-center sm:justify-start">
                    <button type="button" (click)="enterManualBrandMode()"
                        class="text-sm font-semibold text-secondary hover:text-primary  px-3 py-2 touch-manipulation rounded-md">
                        Enter company details manually
                    </button>
                </div>
            </div>
            }
        </div>
        }
        @if (selectedBrand()) {
        @if (brandSelectionSource() === 'api') {
        <div
            class="rounded-lg border border-primary/25 dark:border-primary/30 bg-primary/10 dark:bg-primary/10 p-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div class="min-w-0">
                <p class="text-sm font-semibold text-primary">Does this look like your brand?</p>
                <p class="text-sm text-secondary mt-1 max-w-2xl">Check the details we found below. If anything is wrong,
                    try searching again or enter your details manually.</p>
            </div>
            <div class="flex flex-col sm:flex-row gap-2 shrink-0">
                <button type="button" (click)="trySearchAgainFromReview()"
                    class="secondary-button text-secondary text-center rounded-md px-4 py-2.5 text-sm font-semibold  touch-manipulation whitespace-nowrap">
                    Try search again
                </button>
                <button type="button" (click)="switchToManualFromReview()"
                    class="primary-button text-center rounded-md px-4 py-2.5 text-sm font-semibold  touch-manipulation whitespace-nowrap">
                    Enter manually
                </button>
            </div>
        </div>
        }

        <!-- Currency selector -->
        <div
            class="rounded-lg border border-gray-200 dark:border-white/10 bg-gray-100 dark:bg-zinc-800/50 p-4 flex flex-col gap-y-3">
            <div class="shrink-0 flex flex-row w-full items-center gap-4">
                <div class="min-w-0 flex-1">
                    <p class="text-lg font-semibold text-primary">Operating currency</p>
                    <p class="text-sm text-secondary">Select the currency your campaigns and wallet will use.</p>
                </div>
            </div>
            <div class="flex flex-row flex-wrap gap-2">
                @for (option of currencyOptions; track option.value) {
                <button type="button" (click)="onCurrencySelected(option.value)"
                    [class]="slickOnboardService.brandCurrencyCode() === option.value ? 'primary-go-button' : 'secondary-button text-secondary'"
                    class="px-4 py-2 rounded-md text-sm font-semibold touch-manipulation">
                    {{ option.flag }} {{ option.label }}
                </button>
                }
            </div>
        </div>

        <div
            class="rounded-lg border border-gray-200 dark:border-white/10 bg-gray-100 dark:bg-zinc-800/50 p-4 flex flex-col gap-y-2">

            <div class="shrink-0 flex gap-4 flex-row items-center w-full justify-between">
                @if (!brandReviewEditMode()) {
                <div class="flex flex-row items-center space-x-4 sm:space-x-6 min-w-0">
                    <div class="shrink-0">
                        <img [src]="selectedBrand()?.icon" [alt]="(selectedBrand()?.name ?? '') + ' logo'"
                            class="size-14 sm:size-16 rounded-lg bg-gray-200 dark:bg-gray-800 outline -outline-offset-1 outline-gray-300 dark:outline-white/10 object-contain" />
                    </div>
                    <div class="min-w-0 flex-1">
                        <p class="text-base sm:text-lg font-semibold text-primary truncate">
                            {{ brandDetails()?.name ?? selectedBrand()?.name }}
                        </p>
                        <p class="text-sm sm:text-base text-secondary truncate">
                            {{ brandDetails()?.domain ?? selectedBrand()?.domain }}
                        </p>
                    </div>
                </div>

                <div class="shrink-0 flex flex-row items-center justify-center sm:justify-end">
                    <button (click)="editSelectedBrand()" type="button"
                        class="btn-fab-secondary text-secondary  min-w-11 touch-manipulation flex items-center justify-center"
                        aria-label="Edit brand details">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 sm:size-6">
                            <path
                                d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" />
                            <path d="m15 5 4 4" />
                        </svg>
                    </button>
                </div>
                } @else {
                <p class="text-sm font-semibold text-primary">Edit brand details</p>
                <button type="button" (click)="cancelBrandEdit()"
                    class="secondary-button text-secondary rounded-md px-3 py-2 text-sm font-semibold touch-manipulation">
                    Cancel
                </button>
                }
            </div>

            @if (brandDetailFetchPending()) {
            <p class="text-sm text-secondary py-4" aria-live="polite">Loading brand details…</p>
            } @else if (brandReviewEditMode()) {
            <div class="flex flex-col gap-y-4 pt-4">
                <ng-container *ngTemplateOutlet="editableBrandFields" />
                <div class="w-full flex flex-col sm:flex-row gap-2 sm:justify-end">
                    <button type="button" (click)="cancelBrandEdit()"
                        class="w-full sm:w-auto text-center secondary-button text-secondary rounded-md px-4 py-3 text-base font-semibold touch-manipulation">
                        Cancel
                    </button>
                    <button type="button" (click)="applyBrandEdits()"
                        class="w-full sm:w-auto text-center primary-button rounded-md px-4 py-3 text-base font-semibold touch-manipulation">
                        Save changes
                    </button>
                </div>
            </div>
            } @else {
            <div class="flex flex-col gap-y-4 pt-4">

                @if (brandDetails()?.description) {
                <div>
                    <h4 class="text-md font-semibold text-primary">Description</h4>
                    <p class="mt-1 text-sm text-secondary whitespace-pre-line">{{ brandDetails()?.description }}</p>
                </div>
                }

                @if (brandDetails()?.longDescription && brandDetails()?.longDescription !== brandDetails()?.description)
                {
                <div>
                    <h4 class="text-md font-semibold text-primary">More about this brand</h4>
                    <p class="mt-1 text-sm text-secondary whitespace-pre-line">{{ brandDetails()?.longDescription }}</p>
                </div>
                } @else if (selectedBrand()?.brandId === manualBrandFlowId && !(brandDetails()?.description)) {
                <div>
                    <h4 class="text-md font-semibold text-primary">Description</h4>
                    <p class="mt-1 text-sm text-secondary">You can add more brand details later in your dashboard.</p>
                </div>
                }

                @if ((brandDetails()?.company?.industries?.length ?? 0) > 0) {
                <div>
                    <h4 class="text-md font-semibold text-primary">Industry</h4>
                    <div class="mt-1 flex flex-row flex-wrap gap-2">
                        @for (industry of brandDetails()?.company?.industries; track industry.id) {
                        <span
                            class="inline-flex items-center rounded-md bg-primary/10 dark:bg-primary/15 px-2 py-1 text-sm font-medium text-accent inset-ring inset-ring-primary/30 capitalize">{{
                            industry.emoji }} {{ industry.name }}</span>
                        }
                    </div>
                </div>
                }

                @if ((brandDetails()?.links?.length ?? 0) > 0) {
                <div>
                    <h4 class="text-md font-semibold text-primary">Socials and links</h4>
                    <div class="mt-1 flex flex-col flex-wrap gap-2 sm:flex-row sm:items-center">
                        @for (link of brandDetails()?.links; track $index) {
                        @if (link.url) {
                        <a [href]="link.url" target="_blank" rel="noopener noreferrer"
                            class="inline-flex items-center rounded-md bg-blue-50 dark:bg-blue-400/10 px-2 py-1 text-xs font-medium text-blue-600 dark:text-blue-400 inset-ring inset-ring-blue-400/30 capitalize  sm:min-h-0">{{
                            link.name }}</a>
                        } @else {
                        <span
                            class="inline-flex items-center rounded-md bg-blue-50 dark:bg-blue-400/10 px-2 py-1 text-xs font-medium text-blue-600 dark:text-blue-400 inset-ring inset-ring-blue-400/30 capitalize">{{
                            link.name }}</span>
                        }
                        }
                    </div>
                </div>
                }

            </div>
            }
        </div>


        

        <div
            class="rounded-lg border border-gray-200 dark:border-white/10 bg-gray-100 dark:bg-zinc-800/50 p-4 flex flex-col gap-y-2">
            <div class="shrink-0 flex flex-row w-full items-center gap-4 sm:gap-6">
                <div class="shrink-0">
                    <div
                        class="size-14 sm:size-16 rounded-lg bg-gray-200 dark:bg-gray-800 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-10 text-primary">
                            <path d="M12 13V2l8 4-8 4" />
                            <path d="M20.561 10.222a9 9 0 1 1-12.55-5.29" />
                            <path d="M8.002 9.997a5 5 0 1 0 8.9 2.02" />
                        </svg>
                    </div>
                </div>
                <div class="min-w-0 flex-1">
                    <p class="text-lg font-semibold text-primary">
                        Your Goals
                    </p>
                    <p class="text-base text-secondary">
                        What would you like to achieve working with SHOUT?
                    </p>
                </div>
            </div>

            <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
                @for (goal of goalOptions; track goal.id) {
                <div (click)="onGoalSelect(goal)" role="button" tabindex="0"
                    class="group relative shadow-card-container p-4 sm:p-6 hover:cursor-pointer flex flex-row items-center gap-4 min-h-16 touch-manipulation active:bg-gray-100 dark:active:bg-white/5">
                    <div class="shrink-0">
                        <span class="inline-flex rounded-lg p-3" [class]="goal.color">
                            @switch (goal.id) {
                            @case (1) {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-6">
                                <path
                                    d="M11 6a13 13 0 0 0 8.4-2.8A1 1 0 0 1 21 4v12a1 1 0 0 1-1.6.8A13 13 0 0 0 11 14H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z" />
                                <path d="M6 14a12 12 0 0 0 2.4 7.2 2 2 0 0 0 3.2-2.4A8 8 0 0 1 10 14" />
                                <path d="M8 6v8" />
                            </svg>
                            }
                            @case (2) {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-6">
                                <path d="M16 10a4 4 0 0 1-8 0" />
                                <path d="M3.103 6.034h17.794" />
                                <path
                                    d="M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z" />
                            </svg>
                            }
                            @case (3) {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-6">
                                <rect width="14" height="20" x="5" y="2" rx="2" ry="2" />
                                <path d="M12 18h.01" />
                            </svg>
                            }
                            @case (4) {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-6">
                                <path d="M12 21V7" />
                                <path d="m16 12 2 2 4-4" />
                                <path
                                    d="M22 6V4a1 1 0 0 0-1-1h-5a4 4 0 0 0-4 4 4 4 0 0 0-4-4H3a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h6a3 3 0 0 1 3 3 3 3 0 0 1 3-3h6a1 1 0 0 0 1-1v-1.3" />
                            </svg>
                            }
                            @case (5) {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-6">
                                <path d="M2 21a8 8 0 0 1 13.292-6" />
                                <circle cx="10" cy="8" r="5" />
                                <path d="m16 19 2 2 4-4" />
                            </svg>
                            }
                            @case (6) {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-6">
                                <path d="M12 5H2" />
                                <path d="M6 12h12" />
                                <path d="M9 19h6" />
                                <path d="M16 5h6" />
                                <path d="M19 8V2" />
                            </svg>
                            }
                            @case (7) {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-6">
                                <path d="M16 19h6" />
                                <path d="M16 2v4" />
                                <path d="M19 16v6" />
                                <path d="M21 12.598V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8.5" />
                                <path d="M3 10h18" />
                                <path d="M8 2v4" />
                            </svg>
                            }
                            @case(8) {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-6">
                                <path d="M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17" />
                                <path
                                    d="m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9" />
                                <path d="m2 16 6 6" />
                                <circle cx="16" cy="9" r="2.9" />
                                <circle cx="6" cy="5" r="3" />
                            </svg>
                            }
                            }

                        </span>
                    </div>
                    <div class="flex-1">
                        <h3 class="text-sm font-semibold text-primary">
                            <a class="focus:outline-none">
                                <span aria-hidden="true" class="absolute inset-0"></span>
                                {{ goal.name }}
                            </a>
                        </h3>
                        <p class="mt-0 text-xs text-secondary">{{ goal.description }}</p>
                    </div>
                    @if (onboardingBrandService.goalInformation && onboardingBrandService.goalInformation.id ===
                    goal.id) {
                    <div class="shrink-0 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-6 text-green-600 dark:text-green-400">
                            <circle cx="12" cy="12" r="10" />
                            <path d="m9 12 2 2 4-4" />
                        </svg>
                    </div>
                    }
                </div>
                }
            </div>
        </div>

        <button type="button" (click)="saveBrandDetailsInfo()" [disabled]="brandReviewEditMode()"
            class="w-full sm:w-auto sm:min-w-40 text-center primary-go-button flex flex-row items-center gap-x-4 justify-center rounded-md px-4 py-3 sm:py-1.5 text-base sm:text-sm font-semibold  touch-manipulation order-1 sm:order-2 disabled:opacity-50 disabled:pointer-events-none">

            <p class="block">Continue</p>

            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-5 shrink-0">
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
            </svg>

        </button>



        }
    </div>
</div>

<ng-template #editableBrandFields>
    <div class="w-full flex flex-col gap-y-2">
        <label for="manual-company-name" class="block text-sm/6 font-medium text-primary text-left">Brand
            name</label>
        <input [formField]="manualBrandForm.companyName" id="manual-company-name" type="text"
            placeholder="Acme Ltd" autocomplete="organization"
            class="input-url text-primary text-base  rounded-md w-full" />
        @if (manualBrandForm.companyName().touched() && manualBrandForm.companyName().invalid()) {
        <ul class="list-disc pl-5 text-sm text-red-600 dark:text-red-400 space-y-1" role="alert">
            @for (error of manualBrandForm.companyName().errors(); track error) {
            <li>{{ error.message }}</li>
            }
        </ul>
        }
    </div>

    <div class="w-full flex flex-col gap-y-2">
        <span class="block text-sm/6 font-medium text-primary text-left">Brand logo</span>
        <div class="rounded-lg bg-muted/20 pb-3 dark:bg-zinc-900/40">
            @for (rev of [manualLogoEditorRevision()]; track rev) {
            <atom-add-image [initialImage]="manualBrandModel().logoUrl || undefined"
                [bucket]="S3BucketEnum.PRODUCT_IMAGES" [size]="'sm'"
                (imageUploaded)="onManualLogoUploaded($event)"></atom-add-image>
            }
        </div>
        <label for="manual-logo-url" class="block text-sm/6 font-medium text-primary text-left">Direct
            image URL</label>
        <input [formField]="manualBrandForm.logoUrl" id="manual-logo-url" type="url" inputmode="url"
            placeholder="https://example.com/logo.png" autocomplete="off"
            class="input-url text-primary text-base rounded-md w-full" (blur)="onManualLogoUrlBlur()" />
        <p class="text-xs text-secondary">Upload above or paste a direct link to a PNG, SVG, or JPG (must
            start with https:// or http://).</p>
        @if (manualBrandForm.logoUrl().touched() && manualBrandForm.logoUrl().invalid()) {
        <ul class="list-disc pl-5 text-sm text-red-600 dark:text-red-400 space-y-1" role="alert">
            @for (error of manualBrandForm.logoUrl().errors(); track error) {
            <li>{{ error.message }}</li>
            }
        </ul>
        }
    </div>

    <div class="w-full flex flex-col gap-y-2">
        <label for="manual-website" class="block text-sm/6 font-medium text-primary text-left">Brand
            website</label>
        <div class="mt-0 flex">
            <div
                class="flex shrink-0 items-center rounded-l-md bg-white/50 dark:bg-white/5 px-3 text-base text-gray-500 dark:text-gray-400 outline outline-1 -outline-offset-1 outline-zinc-300 dark:outline-white/10 sm:text-sm/6">
                https://</div>
            <input [formField]="manualBrandForm.website" id="manual-website" type="text"
                placeholder="example.com" autocomplete="url"
                class="input-url text-primary text-base  rounded-r-md flex-1" />
        </div>
        @if (manualBrandForm.website().touched() && manualBrandForm.website().invalid()) {
        <ul class="list-disc pl-5 text-sm text-red-600 dark:text-red-400 space-y-1" role="alert">
            @for (error of manualBrandForm.website().errors(); track error) {
            <li>{{ error.message }}</li>
            }
        </ul>
        }
    </div>

    <div class="w-full flex flex-col gap-y-2">
        <label for="manual-description" class="block text-sm/6 font-medium text-primary text-left">Brand
            description</label>
        <textarea [formField]="manualBrandForm.description" id="manual-description" rows="4"
            placeholder="What does your brand do? Who do you serve?"
            class="input-url text-primary text-base min-h-24 rounded-md w-full py-2"></textarea>
        @if (manualBrandForm.description().touched() && manualBrandForm.description().invalid()) {
        <ul class="list-disc pl-5 text-sm text-red-600 dark:text-red-400 space-y-1" role="alert">
            @for (error of manualBrandForm.description().errors(); track error) {
            <li>{{ error.message }}</li>
            }
        </ul>
        }
    </div>
</ng-template>